'use client';

import { useEffect } from 'react';

import { Capacitor } from '@capacitor/core';
import { App } from '@capacitor/app';
import { StatusBar, Style } from '@capacitor/status-bar';
import { Keyboard } from '@capacitor/keyboard';
import { SplashScreen } from '@capacitor/splash-screen';

import { initieraCrashlytics } from '@/src/lib/crashlytics';

// ----------------------------------------------------------------------

/**
 * Hook to initialize Capacitor native plugins.
 * Call this once in your root layout or app component.
 */
export function useCapacitorInit() {
  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;

    const init = async () => {
      // Initiera Crashlytics tidigt vid appstart
      void initieraCrashlytics();

      // Hide splash screen once app is ready
      await SplashScreen.hide();

      // Configure status bar
      if (Capacitor.isPluginAvailable('StatusBar')) {
        await StatusBar.setStyle({ style: Style.Light });

        if (Capacitor.getPlatform() === 'android') {
          await StatusBar.setBackgroundColor({ color: '#FFFFFF' });
        }
      }

      // Configure keyboard behavior (iOS)
      if (Capacitor.isPluginAvailable('Keyboard')) {
        Keyboard.addListener('keyboardWillShow', () => {
          document.body.classList.add('keyboard-visible');
        });
        Keyboard.addListener('keyboardWillHide', () => {
          document.body.classList.remove('keyboard-visible');
        });
      }

      // Handle hardware back button (Android)
      App.addListener('backButton', ({ canGoBack }) => {
        if (canGoBack) {
          window.history.back();
        } else {
          App.exitApp();
        }
      });
    };

    init();

    return () => {
      App.removeAllListeners();
      if (Capacitor.isPluginAvailable('Keyboard')) {
        Keyboard.removeAllListeners();
      }
    };
  }, []);
}
